import React from "react";
import Accordion from "react-bootstrap/Accordion";

const FAQs = () => {
  const faqsData = [
    {
      question: "O que é o Sistema Integrare?",
      answer:
        "O Integrare é uma plataforma completa de gestão de agências que unifica CRM, controle de projetos, gestão financeira e automação N8N em um único sistema integrado. Desenvolvido pela Rede Integrare, é a solução ideal para agências que buscam eficiência e crescimento.",
    },
    {
      question: "Como funciona a automação N8N integrada?",
      answer:
        "Nossa automação N8N permite conectar todos os processos da sua agência através de fluxos automatizados. Você pode automatizar desde o envio de emails até a integração entre diferentes sistemas, eliminando tarefas repetitivas e acelerando seus resultados. <br /> A integração é nativa e funciona perfeitamente com todos os módulos do Integrare.",
    },
    {
      question: "Meus dados estão seguros no Sistema Integrare?",
      answer:
        "Sim, a segurança é nossa prioridade. O Sistema Integrare utiliza criptografia avançada, autenticação multi-nível, backup automático e todas as melhores práticas de segurança para proteger completamente os dados da sua agência.",
    },
    {
      question: "Qual o custo do Sistema Integrare?",
      answer:
        "Oferecemos diferentes planos para atender agências de todos os tamanhos, desde pequenas agências até grandes operações. Nossos planos incluem todos os recursos principais, suporte dedicado e atualizações contínuas. Entre em contato para conhecer o plano ideal para sua agência.",
    },
    {
      question: "Como posso começar a usar o Sistema Integrare?",
      answer:
        "É muito simples! Clique em 'Criar Conta' para se registrar ou 'Fazer Login' se já possui uma conta. Nossa equipe oferece suporte completo na implementação e treinamento. <br /> Você também pode entrar em contato conosco através do formulário para agendar uma demonstração personalizada.",
    },
  ];

  return (
    <section id="faq" className="section">
      <div className="container">
        <h2 className="text-9 fw-600 text-center">
          Perguntas Frequentes
        </h2>
        <hr className="heading-separator-line bg-primary opacity-10 mx-auto" />
        <p className="lead text-center mb-4">
          Tire suas dúvidas sobre o Sistema Integrare
        </p>
        <div className="row">
          <div className="col-md-10 col-lg-8 mx-auto">
            <hr className="mb-0 opacity-1" />
            <Accordion flush defaultActiveKey="0" className="arrow-end">
              {faqsData.length > 0 &&
                faqsData.map((faq, index) => (
                  <Accordion.Item eventKey={index} key={index}>
                    <Accordion.Header>{faq.question}</Accordion.Header>
                    <Accordion.Body
                      dangerouslySetInnerHTML={{ __html: faq.answer }}
                    ></Accordion.Body>
                  </Accordion.Item>
                ))}
            </Accordion>
            <hr className="mt-0 opacity-1" />
          </div>
        </div>
        <div className="lead text-center mt-4">
          Can't find it here?{" "}
          <a
            href="#contact"
            className="smooth-scroll link-offset-2 link-underline link-underline-opacity-0-hover"
          >
            Tell us your query here.
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQs;
